import React, { Component } from 'react';
import propTypes from 'prop-types';
import Select2Wrap from 'client/components/Form/Select2Wrap';
import { levelSelect2 } from 'client/redux/user/log/constants';
import { UserIdSearcher } from 'client/components/Form/Select2Searchers';
import DateRangePickerWrap from 'client/components/Form/DateRangePickerWrap';
import 'react-bootstrap-daterangepicker/css/daterangepicker.css';

export default class UserLogTableFilterForm extends Component {

  static propTypes = {
    onFilter: propTypes.func,
  };

  handleChange = ev => {
    const newFilter = {...this.props.filter, [ev.target.name]: ev.target.value};
    this.props.onFilter(newFilter);
  };

  render () {
    const { level, userId, type, ip, timeStart, timeEnd } = this.props.filter;
    return (
      <div className="row be-datatable-header xs-pb-10">
        <div className="col-md-3">
          <div className="dataTables_length form-group">
            <DateRangePickerWrap
              startName="timeStart"
              startValue={timeStart}
              endName="timeEnd"
              endValue={timeEnd}
              onChange={this.handleChange}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="dataTables_length form-group">
            <Select2Wrap
              id="userLogTableFilterLevel"
              name="level"
              className="form-control"
              data={levelSelect2}
              options={{minimumResultsForSearch: 20, allowClear: true, placeholder: 'Any level'}}
              onChange={this.handleChange}
              defaultValue={level}
            />
          </div>
        </div>
        <div className="col-md-3">
          <div className="dataTables_length form-group">
            <UserIdSearcher
              id="userLogTableFilterUserId"
              className="form-control"
              name="userId"
              onChange={val => this.handleChange({target: {name: 'userId', value: val}})}
              options={{minimumResultsForSearch: 20, allowClear: true, placeholder: 'Any user'}}
              defaultValue={userId}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="dataTables_length form-group">
            <input
              id="userLogTableFilterType"
              type="text"
              className="form-control"
              name="type"
              onChange={this.handleChange}
              placeholder="Any type"
              value={type}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="dataTables_length form-group">
            <input
              id="userLogTableFilterIp"
              type="text"
              className="form-control"
              name="ip"
              onChange={this.handleChange}
              placeholder="Any ip"
              value={ip}
            />
          </div>
        </div>
      </div>
    );
  }

}
